import { render, staticRenderFns } from "./phdp-index-1.vue?vue&type=template&id=a0eb3db0&scoped=true"
import script from "./phdp-index-1.vue?vue&type=script&lang=js"
export * from "./phdp-index-1.vue?vue&type=script&lang=js"
import style0 from "./phdp-index-1.vue?vue&type=style&index=0&id=a0eb3db0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0eb3db0",
  null
  
)

export default component.exports